module.exports = "<ota-dialog class=\"dialog-room-note-description\" [disbledClose]=\"true\" [closeBottom]=\"true\">\n  <div class=\"description\" [innerHtml]=\"data\"></div>\n</ota-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-room-note-description/dialog-room-note-description.component.html
// module id = 1066
// module chunks = 22